module.exports = __webpack_public_path__ + "img/2330685.png";